// Special Follow-ups mock data (approved HTML:
// 17-Special-Follow-ups-Consistency-Review-v5.html).
// Shared conversation view with task variants. Channel and purpose
// stay separate. Doug's world: Sarah Mitchell + Duke, Gut X paused.

export type FollowupChannel = 'text' | 'email' | 'phone';

export interface FollowupTask {
  id: string;
  channel: FollowupChannel;
  label: string;
  context: string;
  purpose: string;
  reason: string;
  draft: string;
  lastMessage: string;
  lastMessageAt: string;
  sender: string;
  recipient: string;
  destination: string;
  preference: string;
}

export const PRIMARY_TASK: FollowupTask = {
  id: 'followup_sarah_reactivation',
  channel: 'text',
  label: 'Text Follow-up',
  context: 'Reactivation · Assigned to Jamie Dorsey',
  purpose: 'Reconnect with Sarah',
  reason: 'Check how Duke is doing before discussing another order.',
  draft:
    'Hi Sarah, how are things going with Duke? If you need help with his routine or a future order, I’m happy to help.',
  lastMessage:
    'I’d like to cancel the subscription for now while we use our remaining supply.',
  lastMessageAt: 'Sep 18, 2:14 PM Central',
  sender: 'Sarah Mitchell',
  recipient: 'Sarah Mitchell',
  destination: '(615) 555-0148',
  preference: 'Preference 1',
};

export const HORSE = {
  name: 'Duke',
  breed: 'Quarter Horse · Sarah’s horse',
  product: 'Gut X',
  subscriptionStatus: 'Paused by customer',
  customerNeed: 'Confirm current routine',
};

export const NEXT_UP = {
  initials: 'TB',
  name: 'Taylor Brooks',
  description: 'Customer text reply',
  reason: 'Waiting reply · After this task is finished',
};
